module.exports = __webpack_public_path__ + "static/figure_stjudecloud_structure-e43e10bb67f1c48c2a7c1788a802c81c.png";